export default __webpack_public_path__ + "static/media/Stripes_mobile_OffersIcon.fd18f6ad.svg";